export { default } from "./LessonRequirementsHeading";
